<div class="search-result-listing">
  @for (tile of tiles; track tile.id) {
    <app-generic-tile [TileInfo]="tile"></app-generic-tile>
  }
</div>
